(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"/home/sven/ideaprojects/jsgl/node_modules/domready/ready.js":[function(require,module,exports){
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (typeof module != 'undefined') module.exports = definition()
  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
  else this[name] = definition()

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)


  if (!loaded)
  doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener)
    loaded = 1
    while (listener = fns.shift()) listener()
  })

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn)
  }

});

},{}],"/home/sven/ideaprojects/jsgl/node_modules/extend/index.js":[function(require,module,exports){
'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) {/**/}

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0],
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	} else if ((typeof target !== 'object' && typeof target !== 'function') || target == null) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = target[name];
				copy = options[name];

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[name] = extend(deep, clone, copy);

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						target[name] = copy;
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


},{}],"/home/sven/ideaprojects/jsgl/node_modules/performance-now/lib/performance-now.js":[function(require,module,exports){
(function (process){
// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

}).call(this,require('_process'))

},{"_process":"/home/sven/ideaprojects/jsgl/node_modules/process/browser.js"}],"/home/sven/ideaprojects/jsgl/node_modules/process/browser.js":[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],"/home/sven/ideaprojects/jsgl/node_modules/raf/index.js":[function(require,module,exports){
(function (global){
var now = require('performance-now')
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"performance-now":"/home/sven/ideaprojects/jsgl/node_modules/performance-now/lib/performance-now.js"}],"/home/sven/ideaprojects/jsgl/src/Canvas.js":[function(require,module,exports){
(function (global){
"use strict";

var React = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);
var raf = require("raf");

var Canvas = React.createClass({
    displayName: "Canvas",

    getDefaultProps: function () {
        return {
            width: 1000,
            height: 800
        };
    },

    componentDidMount: function () {
        var _this = this;

        if (this.props.main) {
            var screen = this.refs.screen;

            var ctx = screen.getContext("2d");

            var loop = function () {
                try {
                    _this.props.main(ctx);
                } catch (e) {
                    console.error(e);
                }
                raf(loop);
            };

            raf(loop);
        }
    },

    shouldComponentUpdate: function () {
        return false;
    },

    render: function () {
        return React.createElement(
            "canvas",
            {
                ref: "screen",
                width: this.props.width, height: this.props.height,
                onMouseDown: this.props.onMouseDown,
                onMouseMove: this.props.onMouseMove },
            "onDblClick=",
            this.props.onDblClick,
            ">"
        );
    }
});

module.exports = Canvas;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"raf":"/home/sven/ideaprojects/jsgl/node_modules/raf/index.js"}],"/home/sven/ideaprojects/jsgl/src/event-position.js":[function(require,module,exports){
"use strict";

var Vector = require("./vector");

/**
 * Returns a canvas position vector for the given browser event.
 *
 * @param ev    event
 *
 * @returns {Vector}
 */
module.exports = function (ev, screen) {
    var x;
    var y;

    if (ev.pageX || ev.pageY) {
        x = ev.pageX;
        y = ev.pageY;
    } else {
        x = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
        y = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    x -= screen.offsetLeft;
    y -= screen.offsetTop;

    return new Vector(x, y);
};

},{"./vector":"/home/sven/ideaprojects/jsgl/src/vector.js"}],"/home/sven/ideaprojects/jsgl/src/graph.js":[function(require,module,exports){
"use strict";

var Vector = require("./vector");

var TAU = Math.PI * 2;

var extend = require("extend");

function ring(graph, visited, center, minArc, maxArc, depth) {
    var nodes = graph.nodes;

    visited[center] = true;

    var centerNode = nodes[center];
    var i,
        angle,
        refs = centerNode.biref;

    var count = 0;
    for (i = 0; i < refs.length; i++) {
        if (!visited[refs[i]]) {
            count++;
        }
    }

    if (!count) {
        return;
    }

    var arcStep = (maxArc - minArc) / count;
    //console.log("arcStep", arcStep);

    for (i = 0, angle = minArc; i < refs.length; i++, angle += arcStep) {
        var id = refs[i];

        if (!visited[id]) {
            var node = nodes[id];

            var dist = graph.options.separationLimit * depth * 2;
            node.x = Math.cos(angle) * dist;
            node.y = Math.sin(angle) * dist;
            node.depth = depth;

            ring(graph, visited, node.id, angle, angle + arcStep, depth + 1);
        }
    }
}

var DEFAULT_SIZE = 40;

var defaultOptions = {
    /**
     * Zero-force distance for the separating force
     */
    separationLimit: DEFAULT_SIZE * 2.5,
    /**
     * Zero-force distance for the pulling edge force
     */
    edgeLimit: DEFAULT_SIZE * 1.4,
    /**
     * Linear multiplier of the separation force
     */
    separationForceMultiplier: 0.75,
    /** How much velocity gets lost every frame to due friction? */
    friction: 0.16
};

function Graph(options) {
    this.options = extend({}, defaultOptions, options);
    this.nodes = [];

    if (options.friction > 1) {
        throw new Error("Friction must be between 0 and 1");
    }

    this.prevTension = 1000;
}

Graph.prototype.growRandom = function (max) {
    if (typeof max !== "number" && max <= 0) {
        throw new Error("Need max count > 0");
    }

    var nodes = this.nodes;

    this.newNode();

    for (var i = 0; i < max - 1; i++) {
        var idx = Math.random() * nodes.length | 0;

        var n = this.newNode();
        nodes[idx].ref.push(n.id);
    }
};

Graph.prototype.newNode = function () {
    var nodes = this.nodes;

    var n = {
        x: 0,
        y: 0,
        dx: 0,
        dy: 0,
        id: nodes.length,
        ref: []
    };

    nodes.push(n);

    return n;
};

Graph.prototype.ease = function () {
    var nodes = this.nodes;

    var tension = 0;
    var tensionCount = 0;
    var force, i, n, d;

    var separationLimit = this.options.separationLimit;
    var edgeLimit = this.options.edgeLimit;
    var separationForceMultiplier = this.options.separationForceMultiplier;

    for (i = 0; i < nodes.length; i++) {
        n = nodes[i];
        for (var j = nodes.length - 1; j > i; j--) {

            var n2 = nodes[j];
            var v = new Vector(n.x, n.y);
            v.subtract(n2);

            d = v.len();

            if (d < separationLimit) {
                force = Math.sqrt(separationLimit - d) * separationForceMultiplier;

                v.norm(force);

                tension += force;
                tensionCount++;

                n.dx += v.x;
                n.dy += v.y;

                n2.dx -= v.x;
                n2.dy -= v.y;
            }
        }

        var refs = n.ref;
        for (j = 0; j < refs.length; j++) {
            n2 = nodes[refs[j]];

            v = new Vector(n.x, n.y);
            v.subtract(n2);

            d = v.len();

            if (d > edgeLimit) {
                force = Math.sqrt(d - edgeLimit);
                v.norm(force);

                tension += force;
                tensionCount++;

                n.dx -= v.x;
                n.dy -= v.y;

                n2.dx += v.x;
                n2.dy += v.y;
            }
        }
    }

    var frictionMultiplier = 1 - this.options.friction;

    for (i = 0; i < nodes.length; i++) {
        var node = nodes[i];

        node.x += node.dx;
        node.y += node.dy;

        node.dx *= frictionMultiplier;
        node.dy *= frictionMultiplier;
    }

    var current = tension / tensionCount;
    var result = (current + this.prevTension) / 2;
    this.prevTension = current;
    return result;
};

/**
 * Calculates the distance that the graph with the given id has to all other nodes in the graph walking the edges in both
 * directions
 *
 * @param graph     graph
 * @param id        id
 * @param visited   recursive state: nodes visited
 * @param count     recursive state: current distance sum
 * @param depth     recursive state: current depth
 *
 * @returns current distance sum
 */
function distanceToAllOtherNodes(graph, id, visited, count, depth) {
    if (!visited[id]) {
        // if we haven't yet visited the node, count it
        count += depth;

        // and remember we were here
        visited[id] = true;

        // walk over all connected nodes
        var nodes = graph.nodes;
        var ref = nodes[id].biref;
        for (var i = 0; i < ref.length; i++) {
            var n2 = nodes[ref[i]];
            // and continue the walk, now every node counts one step more than we did
            count = distanceToAllOtherNodes(graph, n2.id, visited, count, depth + 1);
        }
    }

    return count;
}

Graph.prototype.arrange = function (center) {
    var nodes = this.nodes;

    var i;

    for (i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!node.biref) {
            node.biref = node.ref.slice();

            for (var j = 0; j < nodes.length; j++) {
                var n2 = nodes[j];

                for (var k = 0; k < n2.ref.length; k++) {
                    if (n2.ref[k] === node.id) {
                        node.biref.push(n2.id);
                    }
                }
            }
        }
    }

    if (!center) {
        var min = Infinity;
        for (i = 0; i < nodes.length; i++) {
            node = nodes[i];
            var sum = distanceToAllOtherNodes(this, node.id, {}, 0, 0);

            //console.log("graph distance", num);

            if (sum < min) {
                center = node.id;
                min = sum;
            }
        }
        //console.log("min", num, center);
    }

    nodes[center].x = 0;
    nodes[center].y = 0;
    nodes[center].depth = 0;

    ring(this, {}, center, 0, TAU, 1);

    return center;
};

Graph.prototype.getNodes = function () {
    return this.nodes;
};

Graph.prototype.clean = function () {
    var cleaned = new Array(this.nodes.length);

    var nodes = this.nodes;
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        cleaned[i] = {
            x: node.x | 0,
            y: node.y | 0,
            ref: node.ref
        };
    }

    return cleaned;
};

module.exports = Graph;

},{"./vector":"/home/sven/ideaprojects/jsgl/src/vector.js","extend":"/home/sven/ideaprojects/jsgl/node_modules/extend/index.js"}],"/home/sven/ideaprojects/jsgl/src/main.js":[function(require,module,exports){
(function (global){
"use strict";

var React = (typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null);
var ReactDOM = (typeof window !== "undefined" ? window['ReactDOM'] : typeof global !== "undefined" ? global['ReactDOM'] : null);

var Canvas = require("./Canvas");
var domReady = require("domready");

var Graph = require("./graph");

var Vector = require("./vector");
var eventPosition = require("./event-position");

var MIN_EASE_RUNS = 100;

var MAX_NODES = 50;
var WIDTH = 1000;
var HEIGHT = 800;

var SIZE = 40;

var SEPARATION_LIMIT = SIZE * 2.5;
var EDGE_LIMIT = SIZE * 1.4;

var TENSION_LIMIT = Math.pow(SIZE, 0.34);

var HALF_SIZE = SIZE / 2;
var HALF_WIDTH = WIDTH / 2;
var HALF_HEIGHT = HEIGHT / 2;

var minX, minY, maxX, maxY, maxDepth;

function updateLimits(graph) {
    minX = Infinity;
    minY = Infinity;
    maxX = -Infinity;
    maxY = -Infinity;
    maxDepth = -Infinity;

    var nodes = graph.getNodes();
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];

        if (isNaN(node.x) || isNaN(node.y)) {
            console.error("NAN", graph);
        }

        minX = Math.min(minX, node.x);
        minY = Math.min(minY, node.y);
        maxX = Math.max(maxX, node.x);
        maxY = Math.max(maxY, node.y);
        maxDepth = Math.max(maxDepth, node.depth || 1);
    }
}

var graph = new Graph({
    separationLimit: SEPARATION_LIMIT,
    edgeLimit: EDGE_LIMIT
});

graph.growRandom(MAX_NODES);
graph.arrange();

updateLimits(graph);

var frame = 0;
//for (var i=0; i < MIN_EASE_RUNS; i++)
//{
//    graph.ease();
//    frame++;
//}

var easing = true,
    stopEasing = false;

var redraw = false;
var offsetX;
var offsetY;

var tensionLimit = TENSION_LIMIT;

var locked = {};

function mainLoop(ctx) {
    var max;

    if (stopEasing) {
        console.log("Stop at #", frame, max);
        //console.log(JSON.stringify(graph.clean()));

        easing = false;
        stopEasing = false;
    }

    if (easing || redraw) {
        redraw = false;

        if (easing) {
            frame++;

            max = graph.ease();

            for (var id in locked) {
                if (locked.hasOwnProperty(id)) {
                    var pos = locked[id];
                    if (pos) {
                        var node = graph.nodes[id];
                        node.x = pos.x;
                        node.y = pos.y;
                    }
                }
            }

            if (draggedNode) {
                var pos = dragCurrent.copy().subtract(offsetX, offsetY);

                draggedNode.x = pos.x;
                draggedNode.y = pos.y;
                draggedNode.dx = 0;
                draggedNode.dy = 0;
            }

            updateLimits(graph);

            window.max = max;
            if (frame > MIN_EASE_RUNS && max < tensionLimit && !draggedNode) {
                stopEasing = true;
            }
        }

        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, 1000, 800);

        ctx.fillStyle = "#f00";
        ctx.strokeStyle = "#444";
        ctx.lineWidth = 3;

        offsetX = HALF_WIDTH - (minX + maxX) / 2;
        offsetY = HALF_HEIGHT - (minY + maxY) / 2;

        //console.log(offsetX, offsetY);

        var nodes = graph.getNodes();
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];

            var refs = n.ref;
            for (var j = 0; j < refs.length; j++) {
                var n2 = nodes[refs[j]];

                if (n.id < n2.id) {
                    ctx.beginPath();
                    ctx.moveTo((n.x | 0) + offsetX, (n.y | 0) + offsetY);
                    ctx.lineTo((n2.x | 0) + offsetX, (n2.y | 0) + offsetY);
                    ctx.stroke();
                }
            }
        }

        for (i = 0; i < nodes.length; i++) {
            n = nodes[i];

            var v = n.depth * 255 / maxDepth | 0;
            ctx.fillStyle = "rgb(" + (255 - v) + ",96, " + v + ")";

            var x = (n.x - SIZE / 2 | 0) + offsetX;
            var y = (n.y - SIZE / 2 | 0) + offsetY;

            ctx.fillRect(x, y, SIZE, SIZE);

            if (locked[n.id]) {
                ctx.strokeRect(x, y, SIZE, SIZE);
            }
        }
    }
}

var draggedNode = null;
var dragLocked;
var dragOffset;
var dragCurrent;
var dragInitial;

function findNode(x, y) {
    var nodes = graph.nodes;

    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];

        if (x >= node.x - HALF_SIZE && x < node.x + HALF_SIZE && y >= node.y - HALF_SIZE && y < node.y + HALF_SIZE) {
            return node;
        }
    }
    return null;
}

var Screen = React.createClass({
    displayName: "Screen",


    componentDidMount: function () {
        console.log("CANVAS REF", this.refs.canvas);

        window.addEventListener("mouseup", this.onMouseUp, true);
    },

    componentWillUnmount: function (ev) {
        window.removeEventListener("mouseup", this.onMouseUp, true);
    },

    onMouseUp: function (ev) {
        if (draggedNode) {
            if (dragLocked) {
                console.log(ev.ctrlKey);

                if (ev.ctrlKey) {
                    var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY);

                    var node = findNode(pos.x, pos.y);
                    if (node) {
                        console.log("toggle", node);

                        if (locked[node.id]) {
                            locked[node.id] = null;
                        } else {
                            locked[node.id] = new Vector(node.x, node.y);
                        }

                        redraw = true;
                    }
                }
            } else {
                var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas));

                if (pos.x < 0 || pos.y < 0 || pos.x >= WIDTH || pos.y >= HEIGHT) {
                    console.log("reset");
                    draggedNode.x = dragInitial.x - offsetX;
                    draggedNode.y = dragInitial.y - offsetY;
                } else {
                    draggedNode.x = pos.x - offsetX;
                    draggedNode.y = pos.y - offsetY;

                    stopEasing = true;
                }
            }
            draggedNode = null;
        }
    },

    onMouseDown: function (ev) {
        //console.log("MOUSE DOWN");

        var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY);

        var node = findNode(pos.x, pos.y);
        if (node) {
            //console.log("DRAG ON", node);
            draggedNode = node;
            dragLocked = true;
            dragOffset = pos.subtract(node);
            dragInitial = new Vector(node.x + offsetX, node.y + offsetY);
        }
    },

    onMouseMove: function (ev) {
        if (draggedNode) {
            var pos = eventPosition(ev, ReactDOM.findDOMNode(this.refs.canvas)).subtract(offsetX, offsetY).add(dragOffset);

            var len = pos.copy().subtract(dragInitial.x - offsetX, dragInitial.y - offsetY).len();
            if (dragLocked && len > 2) {
                dragLocked = false;
                frame = 0;
            }

            if (!dragLocked) {
                //console.log("move to ", pos);

                draggedNode.x = pos.x;
                draggedNode.y = pos.y;

                dragCurrent = pos.add(offsetX, offsetY);
                easing = true;
            }
        }
    },

    render: function () {
        var _this = this;

        return React.createElement(
            "div",
            { className: "screen" },
            React.createElement(
                "div",
                { className: "block", style: {
                        width: WIDTH,
                        height: HEIGHT
                    } },
                React.createElement(Canvas, {
                    ref: "canvas",
                    main: mainLoop,
                    width: WIDTH, height: HEIGHT,
                    onMouseMove: this.onMouseMove,
                    onMouseDown: this.onMouseDown,
                    onDblClick: this.onDblClick
                })
            ),
            React.createElement(
                "div",
                { className: "block" },
                React.createElement(
                    "h1",
                    null,
                    "Random graph layouter"
                ),
                React.createElement(
                    "table",
                    null,
                    React.createElement(
                        "tbody",
                        null,
                        React.createElement(
                            "tr",
                            null,
                            React.createElement(
                                "td",
                                null,
                                React.createElement(
                                    "label",
                                    { htmlFor: "maxNodes" },
                                    "Node Count"
                                )
                            ),
                            React.createElement(
                                "td",
                                null,
                                React.createElement("input", { id: "maxNodes", ref: "maxNodes", type: "text", title: "Number of nodes", defaultValue: MAX_NODES })
                            )
                        ),
                        React.createElement(
                            "tr",
                            null,
                            React.createElement(
                                "td",
                                null,
                                React.createElement(
                                    "label",
                                    { htmlFor: "edgeLimit" },
                                    "Edge Max"
                                )
                            ),
                            React.createElement(
                                "td",
                                null,
                                React.createElement("input", { id: "edgeLimit", ref: "edgeLimit", type: "text", title: "Distance at which an edge will start pulling", defaultValue: EDGE_LIMIT })
                            )
                        ),
                        React.createElement(
                            "tr",
                            null,
                            React.createElement(
                                "td",
                                null,
                                React.createElement(
                                    "label",
                                    { htmlFor: "separationLimit" },
                                    "Separation Threshold"
                                )
                            ),
                            React.createElement(
                                "td",
                                null,
                                React.createElement("input", { id: "separationLimit", ref: "separationLimit", title: "Distance at which the separation force stops", type: "text", defaultValue: SEPARATION_LIMIT })
                            )
                        ),
                        React.createElement(
                            "tr",
                            null,
                            React.createElement(
                                "td",
                                null,
                                React.createElement(
                                    "label",
                                    { htmlFor: "tensionThreshold" },
                                    "Tension Threshold"
                                )
                            ),
                            React.createElement(
                                "td",
                                null,
                                React.createElement("input", { id: "tensionThreshold", ref: "tensionThreshold", type: "text", title: "Tension value to stop at after", defaultValue: TENSION_LIMIT })
                            )
                        ),
                        React.createElement(
                            "tr",
                            null,
                            React.createElement(
                                "td",
                                null,
                                " "
                            ),
                            React.createElement(
                                "td",
                                null,
                                React.createElement("input", { type: "submit", value: "Regenerate", onClick: function () {

                                        graph = new Graph({
                                            separationLimit: +_this.refs.separationLimit.value,
                                            edgeLimit: +_this.refs.edgeLimit.value
                                        });

                                        graph.growRandom(+_this.refs.maxNodes.value);
                                        graph.arrange();
                                        updateLimits(graph);

                                        tensionLimit = +_this.refs.tensionThreshold.value;
                                        frame = 0;
                                        //for (var i=0; i < MIN_EASE_RUNS; i++)
                                        //{
                                        //    graph.ease();
                                        //    frame++;
                                        //}
                                        easing = true;
                                    } }),
                                React.createElement("input", { type: "submit", value: "Ease", onClick: function () {

                                        graph.options.separationLimit = +_this.refs.separationLimit.value;
                                        graph.options.edgeLimit = +_this.refs.edgeLimit.value;
                                        easing = true;
                                    } })
                            )
                        )
                    )
                )
            )
        );
    }
});

domReady(function () {
    ReactDOM.render(React.createElement(Screen, { separationLimit: SEPARATION_LIMIT, edgeLimit: EDGE_LIMIT }), document.getElementById("root"), function () {
        console.log("done");
    });
});

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./Canvas":"/home/sven/ideaprojects/jsgl/src/Canvas.js","./event-position":"/home/sven/ideaprojects/jsgl/src/event-position.js","./graph":"/home/sven/ideaprojects/jsgl/src/graph.js","./vector":"/home/sven/ideaprojects/jsgl/src/vector.js","domready":"/home/sven/ideaprojects/jsgl/node_modules/domready/ready.js"}],"/home/sven/ideaprojects/jsgl/src/vector.js":[function(require,module,exports){
"use strict";

var extend = require("extend");

function Vector(x, y) {
    this.x = x;
    this.y = y;
}

extend(Vector.prototype, {
    add: function (x, y) {
        if (y === undefined) {
            this.x += x.x;
            this.y += x.y;
        } else {
            this.x += x;
            this.y += y;
        }
        return this;
    },
    subtract: function (x, y) {
        if (y === undefined) {
            this.x -= x.x;
            this.y -= x.y;
        } else {
            this.x -= x;
            this.y -= y;
        }
        return this;
    },
    scale: function (s) {
        this.x *= s;
        this.y *= s;
        return this;
    },
    len: function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    norm: function (len) {
        var invLen = (len || 1) / this.len();
        return this.scale(invLen);
    },
    copy: function () {
        return new Vector(this.x, this.y);
    },
    toString: function () {
        return "( " + this.x + ", " + this.y + ")";
    }
});

module.exports = Vector;

},{"extend":"/home/sven/ideaprojects/jsgl/node_modules/extend/index.js"}]},{},["/home/sven/ideaprojects/jsgl/src/main.js"])

